var headroom;


/**
 * Creates a cookie
 *
 * @param string The name of the cookie
 * @param string The value
 * @param int Life
 * @return
 */
 function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

/**
 * Reads a cookie
 *
 * @param string The name of the cookie
 * @return The value, or null
 */
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
/**
 * Erase a cookie
 *
 * @param string The name of the cookie
 * @return
 */
function eraseCookie(name) {
  createCookie(name, "", -1);
}


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
          var myElement = document.querySelector("header");
          // construct an instance of Headroom, passing the element
          headroom = new Headroom(myElement, {
            tolerance: {
              down: 11,
              up: 3
            }
          });
          // initialise
          headroom.init();

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.








var expanded_menu_id = false;
var mouse_over_status_array = [""];
var headerPosition = 'absolute';
var headerHidden = 60;
// Showing mobile version of secondary nav menu?
var mobile_nav_sc = false;


function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function hideDropdown(main_class, no_delay, delay_ms) {
  // Pause to make sure this is what the user wants
  if (!mouse_over_status_array[main_class] && !no_delay) {
    setTimeout("hideDropdown(\"" + main_class + "\", true)", delay_ms);
  }
  // Show the dropdown
  else if (!mouse_over_status_array[main_class]) {
    jQuery("." + main_class + " > ul.sub-menu").hide();
    // Change the parent class
    jQuery("." + main_class).removeClass("hovered_submenu");
  }
}



function showDropdown(main_class, no_delay, delay_ms) {
  // Pause to make sure this is what the user wants
  if (mouse_over_status_array[main_class] && !no_delay) {
    setTimeout("showDropdown(\"" + main_class + "\", true)", delay_ms);
  }
  // Show the dropdown
  else if (mouse_over_status_array[main_class]) {
    jQuery("." + main_class + " > ul.sub-menu").slideDown("fast");
    // Change the parent class
    jQuery("." + main_class).addClass("hovered_submenu");
  }
}

function getScrollTop() {
  if (typeof pageYOffset !== 'undefined') {
    //most browsers except IE before #9
    return pageYOffset;
  } else {
    var B = document.body; //IE 'quirks'
    var D = document.documentElement; //IE with doctype
    D = (D.clientHeight) ? D : B;
    return D.scrollTop;
  }
}



function getHeaderTop(div) {
  var winTop;
  if (!div) {
    winTop = jQuery(window).scrollTop();
  } else {
    winTop = jQuery(div).offset().top;
  }
  var headerTop = winTop;
  if (headerTop > headerHidden) {
    headerTop = headerHidden;
  } else if (headerTop < 0) {
    headerTop = 0;
  }
  return headerTop;
}
// State of the header.
var top_stick = true;
var darker_nav = false;
// Update the navigation based on the width of the viewport.
function updateNav() {

  //
  // Update header background color.
  //
  var from_top = jQuery(window).scrollTop();
  if (from_top > 10 && !darker_nav) {
    jQuery(".header").addClass('darker');
    darker_nav = true;
  } else if (from_top <= 10 && darker_nav) {
    jQuery(".header").removeClass('darker');
    darker_nav = false;
  }


  var doc_width = jQuery(window).width();
  var doc_height = jQuery(window).height();
  if (doc_width <= 1000) {
    //var from_top = jQuery(window).scrollTop();
    var myElement = document.querySelector("header");

    jQuery('.nav-primary ul li.dropdown > a').click(function (e) {
      e.preventDefault();
    });

  } else {
    //jQuery('.nav-primary ul li.dropdown > a').unbind('click');
  }
}




jQuery(document).ready(function () {
  jQuery('html').addClass('js');
  console.log(jQuery("html").attr("class"));

  updateNav();

  //jQuery(window).scroll(jQuery.throttle(65, updateNav));

  jQuery(window).on("debouncedresize", function (event) {
    // Your event handler code goes here.
    updateNav();
  });

  /* Show and hide the mobile menu. */
  jQuery("#mobile-menu").unbind("click").bind("click", function (e) {

    // Slide the mobile menu out.
    if (!jQuery(".wrapper").hasClass('menu-open')) {
      jQuery(".wrapper").addClass("menu-open");

      // Blur the menu
      setTimeout(function () {
        jQuery(".wrapper").addClass("with-transitions");
        jQuery(".wrapper").addClass("menu-blur");
      }, 300);
    }
    // Slide the mobile menu out.
    else {

      jQuery(".wrapper").removeClass("menu-blur");
      setTimeout(function () {
        jQuery(".wrapper").removeClass("menu-open");
      }, 100);

    }
  });



});



function toggle_nav_menu() { 
  // Slide the mobile menu out.
  if (!jQuery(".wrapper").hasClass('menu-open')) {
    jQuery(".wrapper").addClass("menu-open");

    // Blur the menu
    setTimeout(function () {
      jQuery(".wrapper").addClass("with-transitions");
      jQuery(".wrapper").addClass("menu-blur");
    }, 300);
  }
  // Slide the mobile menu out.
  else {

    jQuery(".wrapper").removeClass("menu-blur");
    setTimeout(function () {
      jQuery(".wrapper").removeClass("menu-open");
    }, 100);

  }
}





function update_header() {

  //current_top = jQuery(window).scrollTop();
  current_top = getScrollTop();

  if (current_top > 50) {
    jQuery('.header').addClass('colored');
  } else {
    jQuery('.header').removeClass('colored');
  }

}


jQuery(document).ready(function () {
  update_header();
  //jQuery(window).scroll($.throttle(65, update_header));
});






(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD module
    define(factory);
  } else if (typeof exports === 'object') {
    // CommonJS-like environment (i.e. Node)
    module.exports = factory();
  } else {
    // Browser global
    root.transformicons = factory();
  }
}(this || window, function () {

  // ####################
  // MODULE TRANSFORMICON
  // ####################
  'use strict';

  var
    tcon = {}, // static class
    _transformClass = 'tcon-transform',

    // const
    DEFAULT_EVENTS = {
      transform: ['click'],
      revert: ['click']
    };

  // ##############
  // private methods
  // ##############

  /**
   * Normalize a selector string, a single DOM element or an array of elements into an array of DOM elements.
   * @private
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements
   * @returns {array} Array of DOM elements
   */
  var getElementList = function (elements) {
    if (typeof elements === 'string') {
      return Array.prototype.slice.call(document.querySelectorAll(elements));
    } else if (typeof elements === 'undefined' || elements instanceof Array) {
      return elements;
    } else {
      return [elements];
    }
  };

  /**
   * Normalize a string with eventnames separated by spaces or an array of eventnames into an array of eventnames.
   * @private
   *
   * @param {(string|array)} elements - String with eventnames separated by spaces or array of eventnames
   * @returns {array} Array of eventnames
   */
  var getEventList = function (events) {
    if (typeof events === 'string') {
      return events.toLowerCase().split(' ');
    } else {
      return events;
    }
  };

  /**
   * Event handler for transform events.
   * @private
   *
   * @param {object} event - event object
   */
  var handleEvent = function (event) {
    tcon.toggle(event.currentTarget);
  };

  /**
   * Attach or remove transformicon events to one or more elements.
   * @private
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements to be toggled
   * @param {object} [events] - An Object containing one or more special event definitions
   * @param {boolean} [remove=false] - Defines wether the listeners should be added (default) or removed.
   */
  var setListeners = function (elements, events, remove) {
    var
      method = (remove ? 'remove' : 'add') + 'EventListener',
      elementList = getElementList(elements),
      currentElement = elementList.length,
      eventLists = {};

    // get events or use defaults
    for (var prop in DEFAULT_EVENTS) {
      eventLists[prop] = (events && events[prop]) ? getEventList(events[prop]) : DEFAULT_EVENTS[prop];
    }

    // add or remove all events for all occasions to all elements
    while (currentElement--) {
      for (var occasion in eventLists) {
        var currentEvent = eventLists[occasion].length;
        while (currentEvent--) {
          elementList[currentElement][method](eventLists[occasion][currentEvent], handleEvent);
        }
      }
    }
  };

  // ##############
  // public methods
  // ##############

  /**
   * Add transformicon behavior to one or more elements.
   * @public
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements to be toggled
   * @param {object} [events] - An Object containing one or more special event definitions
   * @param {(string|array)} [events.transform] - One or more events that trigger the transform. Can be an Array or string with events seperated by space.
   * @param {(string|array)} [events.revert] - One or more events that trigger the reversion. Can be an Array or string with events seperated by space.
   * @returns {transformicon} transformicon instance for chaining
   */
  tcon.add = function (elements, events) {
    setListeners(elements, events);
    return tcon;
  };

  /**
   * Remove transformicon behavior from one or more elements.
   * @public
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements to be toggled
   * @param {object} [events] - An Object containing one or more special event definitions
   * @param {(string|array)} [events.transform] - One or more events that trigger the transform. Can be an Array or string with events seperated by space.
   * @param {(string|array)} [events.revert] - One or more events that trigger the reversion. Can be an Array or string with events seperated by space.
   * @returns {transformicon} transformicon instance for chaining
   */
  tcon.remove = function (elements, events) {
    setListeners(elements, events, true);
    return tcon;
  };

  /**
   * Put one or more elements in the transformed state.
   * @public
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements to be transformed
   * @returns {transformicon} transformicon instance for chaining
   */
  tcon.transform = function (elements) {
    getElementList(elements).forEach(function (element) {
      element.classList.add(_transformClass);
    });
    return tcon;
  };

  /**
   * Revert one or more elements to the original state.
   * @public
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements to be reverted
   * @returns {transformicon} transformicon instance for chaining
   */
  tcon.revert = function (elements) {
    getElementList(elements).forEach(function (element) {
      element.classList.remove(_transformClass);
    });
    return tcon;
  };

  /**
   * Toggles one or more elements between transformed and original state.
   * @public
   *
   * @param {(string|element|array)} elements - Selector, DOM element or Array of DOM elements to be toggled
   * @returns {transformicon} transformicon instance for chaining
   */
  tcon.toggle = function (elements) {
    getElementList(elements).forEach(function (element) {
      tcon[element.classList.contains(_transformClass) ? 'revert' : 'transform'](element);
    });
    return tcon;
  };

  return tcon;
}));

jQuery(document).ready(function () {
  transformicons.add('.tcon');
});




jQuery('a[href^="#"]').on('click', function (event) {
  var target = jQuery(this.getAttribute('href'));

  if (target.length) {
    event.preventDefault();

    jQuery('html, body').stop().animate({
      scrollTop: target.offset().top
    }, 300);
  }
});
